<template>
  <div ref="view" class="goods-page" :style="`padding-bottom:${FooterHeight}px`">
    <!-- 菜单栏（内嵌App时隐藏） -->

    <app-header :title="title" back-type="back-app" />

    <!-- 通用商品内容 -->
    <goods-content :content="goodContent" class="content" />

    <!--其它类型 购买btn -->
    <div class="foot">
      <!-- 操作栏 -->
      <div class="footer">
        <p class="price">
          <span class="shop-price">¥{{ goodsInfo.salePrice }}</span>
        </p>
        <!-- goodsType -->
        <div class="btns">
          <button class="btn" @click="backList">返回列表</button>
          <button class="btn" @click="checked" :class="{ 'btn-click-disable': goodsInfo.stockNum === 0 }">
            {{ isChecked ? '已选中' : '选中商品' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodsComponents from './components/goods'
import $goods from '@/api/modules/goods/index.js'
import { mapMutations } from 'vuex'
import { Toast } from 'mint-ui'

// 操作名称
const action = 'buyGoods'
export default {
  components: {
    ...GoodsComponents
  },
  data() {
    return {
      title: '友邻少年',
      FooterHeight: 60,
      goodsIdArr: [],
      goodContent: null,
      goodsInfo: {},
      isChecked: false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  activated() {
    this.goodsIdArr = [this.$route.query.goodsId * 1] || []
    this.isChecked = this.$route.query.isChecked === 'true'
    this.getDetail()
  },
  methods: {
    ...mapMutations({
      checkedGood: 'goods/physical/checkedGood'
    }),
    getDetail() {
      $goods.getDetailByGoodsId({ goodsIds: this.goodsIdArr }).then(res => {
        this.goodContent = res.goodsInfoList[0].guideContent
        this.goodsInfo = res.goodsInfoList[0]
        this.checkedGood({ ...this.goodsInfo, type: 'updata' })
      })
    },
    checked() {
      if (this.goodsInfo.stockNum === 0) {
        Toast({
          message: '商品已售罄',
          position: 'middle'
        })
        return
      }
      this.isChecked = true
      this.checkedGood(this.goodsIdArr[0])
    },
    backList() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
.goods-page {
  &::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }
  .content {
    img {
      width: 100%;
      height: auto;
    }
  }
  .foot {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    border-top: 1px solid #eeeeee;
    // iphoneX only
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;
    // 活动抵扣
    .activity_box {
      position: absolute;
      top: -0.75rem;
      left: 0;
      width: 100%;
      height: 0.88rem;
      background-image: url('../../images/goods0929/act_bg.png');
      background-size: 100% 100%;
      font-size: 0.26rem;
      .act_left,
      .act_right {
        padding-bottom: 6px;
      }
      .act_left {
        width: 45%;
        color: #fff;
        justify-content: center;
        img {
          width: 0.36rem;
          height: 0.36rem;
          margin-right: 0.08rem;
        }
        span {
          font-weight: 600;
        }
      }
      .act_right {
        flex: auto;
        text-align: center;
        justify-content: center;
      }
      .act_right,
      .countDown_box {
        font-weight: 600;
        color: #e6432d;
      }
    }
    .footer {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.18rem 0.47rem;
      border-top: none !important;
      background-color: #fff;
      .price {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .shop-price-integral {
          font-size: 0.36rem;
          font-weight: bold;
          line-height: 0.54rem;
          span {
            color: #00b25a;
          }
        }
        .shop-price {
          font-size: 0.44rem;
          color: #00b25a;
          font-weight: bold;
          line-height: 0.54rem;
        }
        .original-price {
          color: #999999;
          font-size: 0.26rem;
          line-height: 0.32rem;
          margin-top: 0.1rem;
        }
      }

      .btn {
        padding: 0.24rem 0.4rem;
        background-color: #00b25a;
        border-radius: 0.12rem;
        color: #fff;
      }
      .btn-click-disable {
        pointer-events: none;
        background-color: #bbbbbb;
        max-width: 3rem;
        font-size: 0.28rem;
        text-align: center;
      }
      .btns {
        .btn:first-child {
          border-radius: 0.12rem 0 0 0.12rem;
          background: #d7e7e7;
          color: #00b25a;
        }
        .btn:last-child {
          border-radius: 0 0.12rem 0.12rem 0;
        }
      }
    }
    .protocol_box {
      font-size: 0.28rem;
      padding: 0 0.47rem 0.3rem 0.47rem;
      justify-content: flex-start;
      .choose_img_box {
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 3px;
      }
      .warning_text {
        color: #e6432d;
      }
    }
  }
  .warning {
    position: fixed;
    left: 0;
    display: flex;
    width: 100%;
    align-items: center;
    background: #fff2cc;
    padding: 0.07rem 0.07rem 0.07rem 0.24rem;
    font-size: 0.24rem;
    height: 0.4rem;
    z-index: 10;
    .warning-text {
      color: #e65c53;
      text-decoration: underline;
      height: 0.4rem;
      line-height: 0.4rem;
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 99;
  }
}
</style>
